import React, { useState } from 'react';
import { X, Maximize2, Loader2 } from 'lucide-react';
import { Button } from './button';

const PlaygroundImagePreview = ({ imageUrl, onClose, isLoading }) => {
  const [enlargedImage, setEnlargedImage] = useState(null);

  const handleEnlargeImage = () => {
    if (imageUrl) {
      setEnlargedImage(imageUrl);
    }
  };

  const handleCloseEnlarged = () => {
    setEnlargedImage(null);
  };

  if (!imageUrl && !isLoading) {
    return null;
  }

  return (
    <>
      {/* Small preview card */}
      <div className="bg-white rounded-lg shadow-md overflow-hidden border-2 border-gray-200 rounded-xl overflow-hidden">
        <div className="aspect-[4/3] relative bg-gray-100 flex items-center justify-center">
          {imageUrl ? (
            <>
              <img
                src={imageUrl}
                alt="Generated map preview"
                className="w-full h-full object-cover"
              />
              {/* Overlay with action buttons */}
              <div className="absolute bottom-0 left-0 right-0 bg-black bg-opacity-50 text-white p-2
                              hover:bg-opacity-70 transition-colors flex justify-between items-center">
                <span className="text-xs font-medium truncate">Demo Map Preview</span>
                <Button
                  variant="ghost"
                  size="icon"
                  className="h-6 w-6 text-white hover:text-blue-400"
                  onClick={handleEnlargeImage}
                >
                  <Maximize2 className="h-4 w-4" />
                </Button>
              </div>
            </>
          ) : (
            <div className="flex flex-col items-center gap-2">
              <Loader2 className="h-8 w-8 text-gray-400 animate-spin" />
              <p className="text-sm text-gray-500">Generating...</p>
            </div>
          )}
        </div>
      </div>

      {/* Enlarged image modal */}
      {enlargedImage && (
        <div
          className="fixed inset-0 bg-black backdrop-blur-sm bg-opacity-50 flex items-center justify-center z-[9999] p-4"
          onClick={handleCloseEnlarged}
        >
          <div
            className="bg-white rounded-xl w-full max-w-4xl relative"
            onClick={(e) => e.stopPropagation()}
          >
            <div className="flex justify-between items-center p-4 border-b">
              <h3 className="text-lg font-semibold">Demo Map Preview</h3>
              <Button
                variant="ghost"
                size="icon"
                onClick={handleCloseEnlarged}
                className="text-gray-500 hover:text-gray-700"
              >
                <X className="h-6 w-6" />
              </Button>
            </div>
            <div className="p-6">
              <img
                src={enlargedImage}
                alt="Enlarged demo map preview"
                className="w-full h-auto rounded-lg shadow-2xl shadow-black/50"
              />
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default PlaygroundImagePreview;
